import React from 'react';
import { map, isEmpty, find, castArray } from 'lodash';
import SimpleBar from 'simplebar-react';

// local dependencies
import { EndScrollDetector } from 'modules/end-scroll-detector';
import { spinner as Spinner } from 'ui/views/generic/spinner';
import { widgetError as WidgetError } from 'ui/views/widgets/widgetError';
import {  WIDGET_ERROR_TYPE, BLANK_VALUE_SYMBOL } from 'constants/common';

/**
 * @type {object}
 * @desc A React presentation/dumb view component.
 * @example
 * import { callWidgetCategoryReasonSummaryList as CallWidgetCategoryReasonSummaryList } from 'ui/views/widgets/callWidgetCategoryReasonSummaryList';
 *
 * // render
 * <CallWidgetCategoryReasonSummaryList propName='propValue'/>
 */

export const callWidgetCategoryReasonSummaryList = ( props ) => {

    const { items, isInitialData, disablePagination, onPagination, isFetching, fetchingType, options } = props;

    const displayValues = map( castArray( items ), ( groupValue ) => {

        // get parent option based on `groupValue.id` and child options
        const parentOption = find( options, { value: groupValue.category } );
        const childOption = isEmpty( parentOption ) ? [] : find( parentOption.options, { value: groupValue.reason } );

        // construct display values
        return {
            parent: parentOption ?  parentOption.name: BLANK_VALUE_SYMBOL,
            children: childOption.name ?  childOption.name: BLANK_VALUE_SYMBOL
        };
    } );

    return (
        <div className='ui-call-widget-category-reason-summary-list'>
              { isEmpty( displayValues ) ? (
                                <div className='ui-table__body__no-data'>
                                    <WidgetError type={ isInitialData ? WIDGET_ERROR_TYPE.NO_DATA_FOUND : WIDGET_ERROR_TYPE.NO_MATCH_FOUND }/>
                                </div>
                            ) : (
                                <EndScrollDetector
                                    disabled={ disablePagination }
                                    callback={ onPagination }
                                    render={ ( { ref } ) => (
                                        <SimpleBar scrollableNodeProps={ { ref } } style={ { maxHeight: 300, height: 300 } }>
                                            { map( displayValues, ( item, itemIndex ) => {
                                                    return (
                                                        <div key={ itemIndex + item.parent } className="ui-call-widget-category-reason-summary-list__card">
                                                            <p className='ui-call-widget-category-reason-summary-list__card__parent'>{ item.parent }</p>
                                                            <p className='ui-call-widget-category-reason-summary-list__card__children'>{ item.children }</p>
                                                        </div>
                                                    );
                                                } )
                                            }
                                        </SimpleBar>
                                    ) }/>
                            )
                        }

             {/* pagination spinner */}
             {
                isFetching && 'pagination' === fetchingType ? (
                    <div className='ui-table__pagination-spinner'>
                        <Spinner />
                    </div>
                ) : null
            }
        </div>
    );
};

// set display name
callWidgetCategoryReasonSummaryList.displayName = 'callWidgetCategoryReasonSummaryList';

// set default props
callWidgetCategoryReasonSummaryList.defaultProps = {};

// prop types
callWidgetCategoryReasonSummaryList.propTypes = {};
